import { useContext, useEffect, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { useFormikContext } from 'formik'
import objectPath from 'object-path'
import { onUpdateCondition } from 'designer/component/action/condition/Action'
import { getFieldName } from 'designer/component/action/Data'
import useAuth from 'hooks/useAuth'
import { getFieldProps } from './DataControl'

const PropWrapper = (props) => {
  const { children } = props
  const designContext = useContext(DesignContext)
  const { jsonForm, setFormData, widgetName } = designContext
  const { uischema, config } = props
  const auth = useAuth()
  const formikContext = useFormikContext()
  const { errors } = formikContext
  const fieldName = getFieldName(uischema.name, { config, widgetName })
  const fieldKey = getFieldName(uischema.key, { config, widgetName })
  const formData = jsonForm.formData
  const fieldProps = getFieldProps({
    designContext,
    config,
    uischema,
    auth,
  })
  const { uiKey, uiName, data } = fieldProps
  const [isOnChange, setIsOnChange] = useState(false)
  const dataProps = {
    props,
    designContext,
    fieldProps,
    auth,
    fieldName,
    fieldKey,
    errors,
    isOnChange,
    setIsOnChange,
  }

  let mapResponse = objectPath.get(data, ['@mapResponse', uiKey])
  useEffect(() => {
    if (mapResponse) {
      onUpdateCondition(props, designContext, uiKey, data)
      objectPath.del(formData, ['@mapResponse', uischema.key])
      setFormData(formData)
    }
  }, [mapResponse])

  if (typeof children === 'function') {
    return children({ dataProps })
  }
  return null
}

export default PropWrapper
